import React, { useState } from 'react';
import ReportDataModule from '../modules/ReportDataModule.js';
import './Box.css';

const ReportViewBox = ({user, reportId, isSmallScreen}) => {
    const [inputReportId, setInputReportId] = useState(reportId || null);
    const [submittedReportId, setSubmittedReportId] = useState(reportId || null);

    const handleReportIdChange = (e) => {
        setInputReportId(e.target.value);
    };

    const handleSubmit = () => {
        setSubmittedReportId(inputReportId);
    };

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* <h1 className='box-title'> Report View </h1> */}
            <h4></h4>
            {!reportId && user?.subscriptions?.includes('ADMIN') ? (
                <div className="standard-module">
                    <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="reportIdInput" style={{ display: 'block', marginBottom: '8px' }}>
                            Enter Report ID:
                        </label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input
                                id="reportIdInput"
                                type="text"
                                value={inputReportId}
                                onChange={handleReportIdChange}
                                style={{
                                    flex: 1,
                                    padding: '8px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc'
                                }}
                            />
                            <button 
                                onClick={handleSubmit}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#0c7ffa',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                View Report
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
            {submittedReportId ? (
                <ReportDataModule 
                    user={user} 
                    reportId={submittedReportId} 
                    isSmallScreen={isSmallScreen}
                />
            ) : null}
        </div>
    );
}

export default ReportViewBox; 